<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="departement" class="font-light" >Département<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.departement" placeholder="" name="departement" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début absence<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Fin absence<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.endDate" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="type" class="font-light" >Type d'absence<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.type" placeholder="" name="type" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="reprise" class="font-light" >Date de reprise<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.reprise" placeholder="" name="reprise" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-2xl text-black font-normal">Resumption from Leave or Approved Absence</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Name: {{ form.nom ?? "" }}</th>
                            <th class="text-2xl text-black font-normal">Department: {{ form.departement ?? "" }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="text-2xl text-black font-normal">Leave or absence period</th>
                            <th class="text-2xl text-black font-normal">{{ form.startDate ?? "" }} - {{ form.endDate ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Type of leave</th>
                            <th class="text-2xl text-black font-normal">{{ form.type ?? "" }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Resumption date</th>
                            <th class="text-2xl text-black font-normal">{{ form.reprise ?? "" }}</th>
                        </tr>
                    </tbody>
                </table>
                <div class="mt-20 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        Employee’s signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-20 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        Supervisor’s signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-20 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        HR Office signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-40 text-gray-700 mb-4 flex text-[11px]">
                    <p>
                        <span class="font-bold">Provision</span>: This form should be MANDATORILY completed by the employee upon his resumption and sent to the
                        HR Office on the same day.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "ResumptionFromLeave",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                departement: null,
                startDate: null,
                endDate: null,
                type: null,
                reprise: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.departement = null;
            this.form.startDate = null;
            this.form.endDate = null;
            this.form.type = null;
            this.form.reprise = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":25,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>